<template>
    <v-btn @click="$emit('click')" class="ma-1" color="blue-grey" dark x-small >
        <v-icon small>mdi-undo</v-icon> Hoàn tác
    </v-btn>
</template>
<script>
export default {
    
}
</script>